module.exports = __webpack_public_path__ + "static/img/kid-5.5692771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-5.png
// module id = vfeY
// module chunks = 0